import { Box, Button, Stack } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

/**
 * Main container for the payment required alert
 * Full width with horizontal padding
 */
export const StyledAlertContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  paddingTop: theme.spacing(6),
  paddingBottom: theme.spacing(3),
}));

/**
 * Content wrapper with responsive layout
 * Displays as a horizontal row on desktop, wraps on mobile
 */
export const StyledAlertContent = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
  borderRadius: theme.customShape.borderRadiusFull,
  backgroundColor: theme.palette.background.button,
  padding: theme.spacing(3, 6),

  [theme.breakpoints.down('lg')]: {
    borderRadius: theme.customShape.borderRadius3XL,
  },
}));

/**
 * Header section with icon and title
 * Groups warning icon with alert title
 */
export const StyledAlertHeader = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

/**
 * Alert action button
 * Full width on mobile, auto width on desktop with auto margin-left
 */
export const StyledAlertButton = styled(Button)(({ theme }) => ({
  marginLeft: 0,
  width: '100%',

  [theme.breakpoints.up('lg')]: {
    marginLeft: 'auto',
    width: 'auto',
  },
}));
